import {Response} from "../../api/quotationApiClient";

export function handleAfterStepErrors(response: Response, callback?: (Response) => void) {
    if(response.errorResponse.redirectUrl !== null && response.errorResponse.redirectUrl !== ""){
        window.location.href = response.errorResponse.redirectUrl;
    }
    
    if(response && callback)callback(response);
}